import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '@base/environments/environment';
import { HttpService } from '../core/http.service';

@Injectable({
  providedIn: 'root',
})
export class PanelService extends HttpService {
  basePanelUrl = environment.apiEndpoint;
  remaxEndpoint = environment.remaxEndpoint;
  utils: any;

  //------------------------------------------------------------Modulo Inicio

  async getPanelOffices(): Promise<any> {
    const URL = this.basePanelUrl + '/panel/home/agencies/';
    const RESPONSE = await firstValueFrom(this.http.get<any>(URL));
    return RESPONSE;
  }

  async postPanelOffices(office: number, userId: number): Promise<any> {
    const BODY = {
      agencyId: office,
      userId: userId,
    };

    const URL = this.basePanelUrl + '/panel/home/change-agency/';
    const RESPONSE = await firstValueFrom(this.http.post<any>(URL, BODY));
    return RESPONSE;
  }

  async saveOffice(body: any): Promise<any> {
    const URL = this.basePanelUrl + '/agencies';
    const RESPONSE = await firstValueFrom(this.http.post<any>(URL, body));
    return RESPONSE;
  }

  async getClientsSummary(): Promise<any> {
    const URL = this.basePanelUrl + '/panel/home/resumen-clients/';
    const RESPONSE = await firstValueFrom(this.http.get<any>(URL));
    return RESPONSE;
  }
  //------------------------------------------------------------Modulo Herramientas

  //-----Cuentas Corrientes-----
  async postCleanAccounts(office: any): Promise<any> {
    const BODY = { agencyId: office };
    const URL = this.basePanelUrl + '/panel/tools/clean-current-account';
    const RESPONSE = await firstValueFrom(this.http.post<any>(URL, BODY));
    return RESPONSE;
  }

  //-----Eliminar Agente-----
  async getOfficesDeleteAgent(): Promise<any> {
    const URL = this.basePanelUrl + '/panel/tools/agencies-delete-agent';
    const RESPONSE = await firstValueFrom(this.http.get<any>(URL));
    return RESPONSE;
  }

  async getAgentsInfoFromOffice(agencyId: number): Promise<any> {
    const URL = this.basePanelUrl + '/panel/tools/agents-to-delete/' + agencyId;
    const RESPONSE = await firstValueFrom(this.http.get<any>(URL));
    return RESPONSE;
  }

  async postAgentToDelete(personId: any): Promise<any> {
    const BODY = { agencyId: null, personId };
    const URL = this.basePanelUrl + '/panel/tools/agent-to-delete/';
    const RESPONSE = await firstValueFrom(this.http.post<any>(URL, BODY));
    return RESPONSE;
  }

  async deleteAgent(personId: number, agencyId: number): Promise<any> {
    const body = { agencyId, personId };
    const URL = this.basePanelUrl + '/panel/tools/delete-agent/';
    const RESPONSE = await firstValueFrom(this.http.delete<any>(URL, { body }));
    return RESPONSE;
  }

  //-----Recalculo de estadisticas-----
  async getRecalculateStatsAgencies(): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>('/panel/tools/recalculate-statistics/agencies', {
        observe: 'response',
        responseType: 'json',
      })
    );
    return RESPONSE.body;
  }

  async getRecalculateStatsYears(): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(
        this.basePanelUrl + '/panel/tools/recalculate-statistics/years',
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );
    return RESPONSE.body;
  }

  async getRecalculateStatsLogs(): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(
        this.basePanelUrl + '/panel/tools/recalculate-statistics/statistics',
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );
    return RESPONSE.body;
  }

  async postRecalculateStats(
    agencyId: number,
    year: number,
    user: number
  ): Promise<any> {
    const BODY = { agencyId, year, user };
    const RESPONSE = await firstValueFrom(
      this.http.post<any>(
        this.basePanelUrl + '/panel/tools/recalculate-statistics',
        BODY,
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  async deleteStat(id: number): Promise<any> {
    const body = { id };
    const RESPONSE = await firstValueFrom(
      this.http.delete<any>(
        this.basePanelUrl + '/panel/tools/recalculate-statistics',
        {
          body,
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  async getOfficesByName(name: string): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(this.basePanelUrl + '/panel/agencies/search/' + name, {
        observe: 'response',
        responseType: 'json',
      })
    );

    return RESPONSE.body;
  }

  //--------------------Get offices data
  async getAdvancedSearchOffices(): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(this.basePanelUrl + '/panel/agencies/', {
        observe: 'response',
        responseType: 'json',
      })
    );

    return RESPONSE.body;
  }

  async getAdvancedSearchRegions(): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(this.basePanelUrl + '/panel/agencies/regions/', {
        observe: 'response',
        responseType: 'json',
      })
    );

    return RESPONSE.body;
  }

  async getAdvancedSearchSubRegions(regionId: any): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(
        this.basePanelUrl + '/panel/agencies/subregions/' + regionId,
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  async getAdvancedSearchVersions(): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(this.basePanelUrl + '/panel/agencies/versions', {
        observe: 'response',
        responseType: 'json',
      })
    );

    return RESPONSE.body;
  }

  async getAdvancedSearchState(): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(this.basePanelUrl + '/panel/agencies/states', {
        observe: 'response',
        responseType: 'json',
      })
    );

    return RESPONSE.body;
  }

  //--------------------Movements
  async previousMovements(): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(
        this.basePanelUrl + '/panel/agencies/state-movement-options/',
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  async previousRenditions(): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(
        this.basePanelUrl + '/panel/agencies/rendition-movement-options/',
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  async getAdvancedSearchRenditionsAndMovements(
    agencyId: number
  ): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(
        this.basePanelUrl + '/panel/agencies/movements-renditions/' + agencyId,
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  async putMovementState(agencyId: number, state: number): Promise<any> {
    const DTO = {
      agencyId,
      state,
    };

    const RESPONSE = await firstValueFrom(
      this.http.put<any>(
        this.basePanelUrl + '/panel/agencies/state-movement/',
        DTO,
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  async putRenditionState(agencyId: number, state: number): Promise<any> {
    const DTO = {
      agencyId,
      state,
    };

    const RESPONSE = await firstValueFrom(
      this.http.put<any>(
        this.basePanelUrl + '/panel/agencies/rendition-state-movement/',
        DTO,
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  //--------------------Advanced Search
  async postAdvancedSearch(
    region?: number | null,
    agency?: number | null,
    version?: number | null,
    state?: number | null
  ): Promise<any> {
    const body = {
      region,
      agency,
      version,
      state,
    };

    const RESPONSE = await firstValueFrom(
      this.http.post<any>(this.basePanelUrl + '/panel/agencies/search/', body, {
        observe: 'response',
        responseType: 'json',
      })
    );

    return RESPONSE.body;
  }

  async getUsersFromAagency(agencyId: number): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(
        this.basePanelUrl + '/panel/agencies/users/' + agencyId,
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  async getRecalculateOffice(agencyId: number, year: number): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(
        environment.apiEndpoint +
          '/movement/recalculateCashFlow/' +
          agencyId +
          '/' +
          year +
          '/',
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  async unsubscribeOffice(body: any): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.post<any>(
        this.basePanelUrl + '/panel/agencies/agency-down',
        body,
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  async subscribeOffice(body: any): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.post<any>(
        this.basePanelUrl + '/panel/agencies/agency-high',
        body,
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  async putEditOffice(body: any): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.put<any>(this.basePanelUrl + '/panel/agencies/', body, {
        observe: 'response',
        responseType: 'json',
      })
    );

    return RESPONSE.body;
  }

  //------------------------------------------------------------Modulo Awards

  async getAwardsYears(): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(this.basePanelUrl + '/panel/awards/years/', {
        observe: 'response',
        responseType: 'json',
      })
    );

    return RESPONSE.body;
  }

  async getAwardsData(agencyId: number): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.get<any>(
        this.basePanelUrl + '/panel/awards/amounts/' + agencyId,
        {
          observe: 'response',
          responseType: 'json',
        }
      )
    );

    return RESPONSE.body;
  }

  async putAwards(body: any): Promise<any> {
    const RESPONSE = await firstValueFrom(
      this.http.put<any>(this.basePanelUrl + '/panel/awards/', body, {
        observe: 'response',
        responseType: 'json',
      })
    );

    return RESPONSE.body;
  }
}
